import { render, staticRenderFns } from "./PricingHelpersAndTrucks.vue?vue&type=template&id=33065f31&"
import script from "./PricingHelpersAndTrucks.vue?vue&type=script&lang=js&"
export * from "./PricingHelpersAndTrucks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports